import React from "react";
import { Link } from "react-router-dom";

const STATUS_STYLES = {
  Active: "border-bd-gold text-bd-gold",
  "In Development": "border-white/40 text-bd-ivory/80",
  "Future Venture": "border-white/20 text-bd-ivory/50",
};

export function StatusBadge({ status, dark = true }) {
  const cls = STATUS_STYLES[status] || "border-white/30 text-bd-ivory/70";
  return (
    <span
      data-testid={`status-badge-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-block px-3 py-1 text-[0.65rem] tracking-[0.18em] uppercase border ${cls}`}
    >
      {status}
    </span>
  );
}

export default function VentureCard({ venture, index = 0 }) {
  const accent = venture.accent || "#B89C65";
  return (
    <Link
      to={`/ventures/${venture.slug}`}
      data-testid={`venture-card-${venture.slug}`}
      className="group relative block bg-bd-charcoal border border-white/10 overflow-hidden transition-transform duration-500 hover:-translate-y-1.5"
    >
      <div className="relative h-44 overflow-hidden bg-bd-black">
        {venture.cover_url ? (
          <img
            src={venture.cover_url}
            alt={venture.name}
            className="w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <span className="font-serif text-6xl select-none" style={{ color: accent, opacity: 0.25 }}>
              {venture.name?.[0] || "B"}
            </span>
          </div>
        )}
        <div className="absolute top-4 left-4">
          <StatusBadge status={venture.status} />
        </div>
        <div className="absolute bottom-0 left-0 h-[2px]" style={{ background: accent, width: "0%" }} />
      </div>
      <div className="p-6">
        <p className="overline text-bd-gold/70 mb-3 text-[0.6rem]">{venture.industry || "Venture"}</p>
        <h3 className="font-serif text-2xl text-bd-ivory mb-2 leading-tight">{venture.name}</h3>
        <p className="text-sm text-bd-ivory/55 leading-relaxed line-clamp-3">{venture.public_summary || venture.tagline}</p>
        <span className="mt-5 inline-block text-xs tracking-[0.18em] uppercase text-bd-gold group-hover:text-bd-gold2 transition-colors">
          View venture →
        </span>
      </div>
    </Link>
  );
}
